import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';
import { ConfirmareDocumenteService } from './confirmare-documente.service';
import { HttpClient } from '@angular/common/http';
import { AppFilesService } from 'src/app/services/app-files.service';
import { DataTablesResponse } from 'src/app/interfaces/data-table-response.interface';

@Component({
    selector: 'app-confirmare-documente',
    templateUrl: './confirmare-documente.component.html',
    styleUrls: ['./confirmare-documente.component.scss']
})
export class ConfirmareDocumenteComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild(DataTableDirective, { static: false })
    dtElement!: DataTableDirective;
    helper = helper;

    isLoading = false;
    showCard = false;

    dtOptions: any = {};
    dtTrigger: Subject<any> = new Subject<any>();
    dtInstance!: DataTables.Api;

    scopParameters: { key: string; value: number }[] = [
        { key: '-- Toate --', value: -1 },
        { key: 'Cu specificație', value: 0 },
        { key: 'Vânzare', value: 1 },
        { key: 'Succesiune', value: 2 },
    ];

    parameters: { key: string; value: number }[] = [
        { key: '-- Toate --', value: -1 },
        { key: 'Da', value: 1 },
        { key: 'Nu', value: 0 },
    ];

    resetForm() {
        this.searchParamsForm.reset(this.initialFormValues);
        this.rerenderDT();
        this.showCard = true;
    }

    applyFilters(): void {
        this.rerenderDT(true);
    }

    toggleCard() {
        this.showCard = !this.showCard;
    }

    searchParamsForm!: FormGroup;

    //Form Initial Values

    initialFormValues = {
        // scopcf: -1,
        // fara_lista_patrimoniu: -1,
        confirmed: -1,
        numar_solicitare: '',
        cnp_cui: '',
        // rol_id: '',
        full_name: '',
    };

    buildSearchParamsForm() {
        this.searchParamsForm = new FormGroup({
            // scopcf: new FormControl(-1),
            // fara_lista_patrimoniu: new FormControl(-1),
            confirmed: new FormControl(-1),
            numar_solicitare: new FormControl(''),
            cnp_cui: new FormControl(''),
            // rol_id: new FormControl(''),
            full_name: new FormControl(''),
        });
    }

    dtLink =
        environment.interop.basePath +
        environment.interop.urbanism.nomenclatoare.confirmareDocumente.getDocumenteCofirmareDT;

    constructor(
        private http: HttpClient,
        private confirmareDocumenteService: ConfirmareDocumenteService,
        private appFilesService: AppFilesService,
    ) { }

    ngOnInit(): void {
        this.renderDT();
        this.buildSearchParamsForm();
    }

    ngAfterViewInit(): void {
        this.dtTrigger.next('');
    }

    ngOnDestroy(): void {
        this.dtTrigger.unsubscribe();
    }

    renderDT() {
        this.isLoading = true;
        this.dtOptions = {
            serverSide: true,
            searching: false,
            responsive: true,
            order: [0, 'desc'],

            ajax: (dataTablesParameters: any, callback: any) => {
                this.isLoading = true;
                Object.assign(dataTablesParameters, { ...this.searchParamsForm.value });

                this.http
                    .post<DataTablesResponse>(this.dtLink, dataTablesParameters)
                    .subscribe((resp: any) => {
                        this.isLoading = false;
                        callback({
                            recordsTotal: resp.data.recordsTotal,
                            recordsFiltered: resp.data.recordsFiltered,
                            data: resp.data.data,
                        });
                    });
            },
            language: environment.config.romanianLanguageDataTable,
            columns: [
                {
                    title: 'ID',
                    data: 'id_confirmare',
                },
                {
                    title: 'Solicitare',
                    data: 'cerere_info',
                    orderable: false,
                },
                {
                    title: 'Cetățean/Companie',
                    data: 'name',
                    orderable: false,
                },
                {
                    title: 'CNP/CUI',
                    data: 'cnp_reprezentant',
                    orderable: false,
                },
                {
                    title: 'Status',
                    data: 'status',
                    orderable: false,
                },
                {
                    title: 'Document generat',
                    data: 'created_at',
                },
                {
                    title: 'Ultima actualizare',
                    data: 'updated_at',
                },
                {
                    title: 'Acțiuni',
                    data: null,
                    orderable: false,
                    className: 'all',
                    render: () => {
                        return `
                            <button style="color: #fff;" class="action-btn signatures">
                                DESCARCĂ
                            </button>
                        `;
                    },
                },
            ],
            rowCallback: (row: Node, data: any[] | any) => {
                const lastTd = (row as HTMLElement).querySelector('td:last-child');
                const downloadButton = lastTd?.querySelector('.signatures') as HTMLElement;

                if (downloadButton) {
                    downloadButton.addEventListener('click', () => {
                        this.downloadDocument(data.document_id);
                    });
                }

                return row;
            },
        };
    }

    rerenderDT(paginate = false): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw(paginate);
        });

        this.showCard = false;
    }

    downloadDocument(id: number) {
        let fullPath = this.confirmareDocumenteService.fileDownloadUrl + id;
        this.isLoading = true;
        this.appFilesService.downloadFile(fullPath)
            .then(() => {
                this.isLoading = false;
            })
            .catch(err => {
                console.error('File download error: ', err);
                this.isLoading = false;
            })
    }
}
